import { RouteProps } from '../../routes/AppRouter'
import { ApplicationTable } from '../../features/application'
import { Title } from '../../components/common/Title'

export const Table = (props: RouteProps) => {
  return (
    <>
      <Title color={"black"} title={props.title || ''} />
      <ApplicationTable />
    </>
  )
}
